import { useEffect, useRef } from 'react';
import { X } from 'lucide-react';
import Button from './Button';

// §2.5 Expanded-row side panel: 360px, opens on row click or Space, replaces page-local view/edit modals.
// Escape closes; ≤ 1180px it opens in front of the grid.
export default function ExpandedRowPanel({ open, title, onClose, children, footer, label = 'Details' }) {
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const onKey = e => { if (e.key === 'Escape' && ref.current?.contains(document.activeElement)) onClose?.(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);
  if (!open) return null;
  return (
    <aside className="ui ui-xp" aria-label={label} ref={ref}>
      <header className="ui-xp__head"><h2 className="ui-xp__title">{title}</h2><Button variant="quiet" iconOnly icon={X} label="Close panel" onClick={onClose} /></header>
      <div className="ui-xp__body">{children}</div>
      {footer && <footer className="ui-xp__foot">{footer}</footer>}
    </aside>
  );
}
